import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { boundHideGdpr } from '../redux/actions/display';
import setPurposesPositive from '../utilities/consent_string/set_purposes_positive';
import updateConsent from '../utilities/consent_string/update_consent';

const StyledFooter = styled.div`
    background-color: ${props => props.theme.footer.backgroundColor};
    border-top: 2px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 0 10px;
    height: 70px;
`;

const Button = styled.button`
    background-color: transparent;
    border: 2px solid ${props => props.theme.footer.btnColor};
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    color: ${props => props.theme.footer.btnColor};
    text-transform: uppercase;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 200ms cubic-bezier(0.39, 0.575, 0.565, 1);
    padding: 10px;
    width: 300px;

    @media screen and (max-width: 570px) {
        font-size: 12px;
        text-align: center;
        padding: 10px 5px;
    }
`;

const DarkButton = styled(Button)`
    background-color: ${props => props.theme.footer.btnColor};
    border-color: transparent;
    color: ${props => props.theme.footer.activeBtnColor};

    @media screen and (max-width: 570px) {
        font-size: 12px;
        text-align: center;
        padding: 10px 5px;
    }
`;

const mapDispatchToProps = () => ({
    hideGdpr: boundHideGdpr,
});

const Footer = ({ location, history, hideGdpr }) => {
    const onIndex = location.pathname === '/';
    const saveSettings = () => {
        updateConsent();
        hideGdpr();
    };

    const navigateSettings = () => {
        history.push('/settings');
    };

    const acceptAll = () => {
        setPurposesPositive();
        hideGdpr();
    };

    return (
        <StyledFooter>
            <Button onClick={onIndex ? navigateSettings : saveSettings}>{onIndex ? 'Настройки' : 'Запази'}</Button>
            <DarkButton onClick={acceptAll}>Приемам всички</DarkButton>
        </StyledFooter>
    );
};


export default withRouter(connect(mapDispatchToProps)(Footer));